<template>
    <div class="col-md-6 col-sm-12 px-1">
        <div class="card mb-2">
            <div class="card-body position-card">
                <div class="position">{{ position }}</div>
                <p class="name mb-2">{{ time.name }}</p>
                <p class="weapon-details"><span class="label">Gun Type:</span> <span class="value">{{ time.weapon_type.title }}</span> <span class="label">/</span> <span class="label">Gun Model:</span> <span class="value">{{ time.weapon }}</span> <span class="label">/</span> <span class="label">BB Weight:</span> <span class="value">{{ time.bb_weight }}</span><template v-if="viewLevel === 'group'">&nbsp;<span class="label">/</span> <span class="label">Board:</span> <span class="value">{{ time.board.title }}</span></template></p>
                <div class="timestamp"><span class="label">Recorded Date:</span> <span class="value">{{ time.recorded_date }}</span></div>
                <div class="time">{{ formatTime(time.time) }}</div>
                <div class="logo-wrapper">
                    <img src="/images/icon.png" alt="Extreme Airsoft Icon" class="logo">
                </div>
                <template v-if="authUser && ! fullscreen">
                <div @click="editTime()" class="edit-time-wrapper" title="Edit Time">
                    <i class="fas fa-edit"></i>
                </div>
                <div @click="deleteTime()" class="delete-time-wrapper" title="Delete Time">
                    <i class="fas fa-times"></i>
                </div>
                </template>
            </div>
        </div>
        <b-modal :visible="editTimeShow" centered @ok="resetEdit" ok-only ok-title="Close" @close="resetEdit" title="Edit Time">
            <form @submit.prevent="submitTime" class="form-inline">
                <div class="form-group mr-2">
                    <label for="name" class="sr-only">Name</label>
                    <input type="text" name="name" id="name" v-model="timeEdit.name" placeholder="Name" class="form-control">
                </div>
                <div class="form-group mr-2">
                    <label for="time" class="sr-only">Time</label>
                    <input type="text" name="time" id="time" v-model="timeEdit.time" placeholder="Time 00:00.00" class="form-control">
                </div>
                <div class="form-group mr-2">
                    <label for="gunType" class="sr-only">Gun Type</label>
                    <select name="gunType" id="gunType" v-model="timeEdit.weapon_type_id" class="form-control" placeholder="Gun Type">
                        <option v-for="typeOption in weaponTypes" :value="typeOption.id" :key="typeOption.id">{{ typeOption.title }}</option>
                    </select>
                </div>
                <div class="form-group mr-2">
                    <label for="gunModel" class="sr-only">Gun Model</label>
                    <input type="text" name="gunModel" id="gunModel" v-model="timeEdit.weapon" placeholder="Gun Model" class="form-control">
                </div>
                <div class="form-group mr-2">
                    <label for="bbWeight" class="sr-only">BB Weight</label>
                    <input type="text" name="bbWeight" id="bbWeight" v-model="timeEdit.bb_weight" placeholder="BB Weight" class="form-control">
                </div>
                <button type="submit" class="btn btn-primary">Edit Time</button>
            </form>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        position: { default: 0 },
        time: { default: false },
        fullscreen: { default: false },
        viewLevel: { default: null },
    },
    data() {
        return {
            authUser: window.authUser || false,
            modal: window.modal,
            weaponTypes: [],
            editTimeShow: false,
            timeEditBase: {
                id: null,
                name: null,
                time: null,
                weapon_type_id: null,
                weapon: null,
                bb_weight: null,
            },
            timeEdit: {},
            submitting: false,
        }
    },
    methods: {
        formatTime(time) {
            let displayTime = "";
            let min = Math.floor(time / 60);
            if (min) {
                // Make sure that the minutes are always 2 digits
                min = min.toString();
                if (min.length === 1) {
                    min = '0' + min;
                }
                displayTime += `${min}:`;
            } else {
                displayTime += '00:';
            }
            let sec = time;
            sec = sec.toString();
            let secParts = sec.split('.');
            secParts[0] = '0' + (secParts[0] % 60);
            if (secParts.length > 1) {
                displayTime += `${secParts[0].slice(-2)}.${secParts[1].slice(0,2)}`;
            } else {
                displayTime += `${secParts[0].slice(-2)}.00`;
            }

            return displayTime;
        },
        editTime() {
            this.$emit('edit');
            Object.assign(this.timeEdit, this.time);
            this.timeEdit.time = this.formatTime(this.timeEdit.time);
            this.editTimeShow = true;
        },
        submitTime() {
            if ( ! this.submitting) {
                this.submitting = true;
                axios.put(`/score/update/${this.time.id}`, this.timeEdit)
                .then((response) => {
                    this.resetEdit();
                    this.submitting = false;
                })
                .catch((e) => {
                    console.error(e);
                })
            }
        },
        resetEdit() {
            this.editTimeShow = false;
            Object.assign(this.timeEdit, this.timeEditBase);
            this.$emit('editfinished');
        },
        deleteTime() {
            this.modal.title = 'Delete Time';
            this.modal.body = `Are you sure that you want to delete ${this.time.name} time?`;
            this.modal.confirm(() => {
                axios.delete(`/score/delete/${this.time.id}`)
                .then((response) => {
                    this.$emit('delete', this.time);
                })
                .catch((e) => {
                    console.error(e);
                })
            });
        }
    },
    mounted() {
        this.resetEdit();
        if (this.authUser) {
            setTimeout(() => {
                axios.get('/weapontype')
                    .then((result) => {
                        this.weaponTypes = result.data;
                    })
                    .catch((err) => {
                        console.error(err);
                    })
            }, 10);
        }
    }
}
</script>